<ng-template cellTemplate let-dataItem="dataItem">
    <fui-image class="image-view" (click)="$event['ignoreClickOutside'] = true"
               [imageBase64]="(dataItem | property: field) ||
                    (component && canLazyLoadImage(dataItem | property: component) && (imageService.lazyLoadImage(dataItem | property: component) | async)) ||
                    (placeholderImageField && (dataItem | property: placeholderImageField)) ||
                    (placeholderImageComponent && canLazyLoadImage(dataItem | property: placeholderImageComponent) && (imageService.lazyLoadImage(dataItem | property: placeholderImageComponent) | async))"
               [imageOpacity]="dataItem | property: imageOpacityField"
               [allowSvg]="allowSvg">
    </fui-image>
</ng-template>
<ng-template editTemplate
             let-column="column"
             let-columnIndex="columnIndex"
             let-dataItem="dataItem"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex" [editControl]="editControl"
                                  [select]="true"></wbo-edit-grid-cell-activator>
    <fui-image-control #editControl (focussed$)="columnFocusHandler(columnIndex)"
                       (valueChange)="controlValueChange($event, dataItem, formGroup)"
                       [imageOpacity]="imageOpacityField ? formGroup.get(imageOpacityField).value : 1"
                       (imageOpacityChange)="controlImageOpacityChange($event, dataItem, formGroup)"
                       [attr.id]="elementId"
                       [control]="formGroup.get(column.field)"
                       [formControl]="formGroup.get(column.field)"
                       [label]="title"
                       [placeholder]="getPlaceholder(dataItem)"
                       [readOnly]="cellDisabled(formGroup, dataItem)"
                       [maxImageSize]="maxImageSize"
                       [allowSvg]="allowSvg"
                       [showOpacitySlider]="showOpacitySlider">
    </fui-image-control>
</ng-template>
